import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { connect } from 'react-redux';
import { asyncRequest, Entities, fetchById, search, TOMCAT_URL } from 'src/common';
import { addErrorNotification } from 'src/actions/notifications';

class EmailToJourneyInfoModal extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.state = {
            startedFetching: false,
            showFormResult: false,
            loading: false,
            offerUrl: null,
            positive: props.emailToJourney.openAIPositiveAnswer,
        };
    }

    callSubmit() {
        return this.childForm.submit();
    }

    didFormChange() {
        return !this.childForm.pristine;
    }

    render() {
        const { loading, offerUrl } = this.state;
        const { emailToJourney, t } = this.props;

        return (
            <div className="col-md-12">
                <div style={{ display: 'flex', flexDirection: 'row', gap: 5 }}>
                    <div className="col-md-12">
                        {t('email_to_journey.create_offer')}:
                        <button
                            type="button"
                            className="btn transparent"
                            onClick={() => {
                                asyncRequest(
                                    `${TOMCAT_URL}api/${Entities.EMAIL_TO_OFFER.repository}/create-link/${emailToJourney.token}`,
                                )
                                    .then(response => {
                                        const json = response.json;
                                        if (json && json.url) {
                                            const win = window.open(json.url, '_blank');
                                            if (win != null) win.focus();
                                        }
                                    })
                                    .catch(error => console.error('Error creating Link', error));
                            }}>
                            <span className="glyphicon glyphicon-log-out text-info" />
                        </button>
                    </div>
                </div>
                <div className="col-md-12">
                    <div style={{ display: 'flex', flexDirection: 'row', gap: 5 }}>
                        {t('email_to_journey.was_this_request_helpful')}
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                            <button
                                className={`glyphicon glyphicon-thumbs-up transparent no-border ${this.state.positive ? 'text-success' : ''}`}
                                onClick={e => {
                                    this.rateEmailToJourney(e, true);
                                }}
                            />
                            <button
                                className={`glyphicon glyphicon-thumbs-down transparent no-border ${!this.state.positive ? 'text-danger' : ''}`}
                                onClick={e => {
                                    this.rateEmailToJourney(e, false);
                                }}
                            />
                        </div>
                    </div>
                </div>
                <button
                    className="btn pull-right btn-primary"
                    style={{ marginBottom: 10 }}
                    onClick={() => {
                        this.props.refetch();
                        this.props.handleClose();
                    }}>
                    {t('find_my_bus.close_modal')}
                </button>
            </div>
        );
    }

    rateEmailToJourney(e, positive) {
        e.target.classList.add(positive ? 'text-success' : 'text-danger');
        this.setState({ positive: positive });
        asyncRequest({
            method: 'PATCH',
            endpoint: `${TOMCAT_URL}api/${Entities.EMAIL_TO_OFFER.repository}/rate-request?emailToJourneyId=${this.props.emailToJourney.id}&positive=${positive}`,
        })
            .then(response => {})
            .catch(error => {
                console.log('Error', error);
            });
    }
}

const mapStateToProps = (state, ownProps) => {
    return {};
};

export default connect(
    mapStateToProps,
    {
        fetchById,
        search,
        addErrorNotification,
    },
    null,
    { withRef: true },
)(EmailToJourneyInfoModal);
